import React, { useState, useEffect } from "react";
import { DatePicker, Button, Dropdown, Tooltip, notification } from "antd";
import Table from "./table/AlarmReportTable";
import { HiOutlineInboxArrowDown } from "react-icons/hi2";
import { DownOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import alarmDatewiseFilter from "./AlarmDatewiseFilter";
import { useReportsStore } from "../ReportsStore";
import { useSearchParams } from "react-router-dom";
import "../reports.scss";
import dbstorage from "../../../lib/DBStorage";

import notificationFilter from "../../../components/NotificationFilter";
import { useComponentStore } from "../../../components/ComponentsStore";
const AlarmDatewiseReport = () => {
  const [userGroup, setUserGroup] = useState("users");
  const yesterday = dayjs().subtract(1, "day");
  const { setNotificationCount } = useComponentStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const {
    alarmReportUserType,
    setAlarmReportUserType,
    alarmReportFirstRender,
    setAlarmFirstRender,
    alarmReportSelectFilter,
    setAlarmReportSelectFilter,
  } = useReportsStore();
  const labelToValueMapping = {
    "All USERS": "users",
    ADMIN: "admin",
    PROD: "users",
    TEST: "test",
  };
  const selectOptions = {
    value: alarmReportUserType,
    items: [
      { key: 1, label: "All USERS" },
      { key: 2, label: "PROD" },
      { key: 3, label: "TEST" },
      { key: 4, label: "ADMIN" },
    ],

    setFilter: ({ key }) => {
      const val = selectOptions.items.find((e) => {
        return e.key === Number(key);
      }).label;
      setAlarmReportUserType(val);
      setUserGroup(labelToValueMapping[val]);
    },
  };

  const handleDatePicker = (date) => {
    if (date) {
      setAlarmReportSelectFilter(date);
      return;
    }
    setAlarmReportSelectFilter(dayjs().subtract(1, "day"));
  };
  const disableFutureDate = (current) => {
    return current && current.isAfter(yesterday);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      if (alarmReportFirstRender) {
        let selectFilter = searchParams.get("alarmReportSelectFilter");
        let userType = searchParams.get("alarmReportUserType");
        if (
          selectFilter !== undefined &&
          selectFilter?.length > 0 &&
          userType?.length > 0
        ) {
          setAlarmReportSelectFilter(dayjs(selectFilter));
          setAlarmReportUserType(userType);
        } else if (selectFilter !== undefined && selectFilter?.length > 0) {
          setAlarmReportSelectFilter(dayjs(selectFilter));
        } else if (userType?.length > 0) {
          setAlarmReportUserType(userType);
        }
        setAlarmFirstRender(false);
      }
      const jslFeedbackData = await alarmDatewiseFilter.getAlarmDatewiseReport(
        alarmReportSelectFilter,
        userGroup
      );
      setTableData(jslFeedbackData);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  const updateQueryParams = () => {
    setSearchParams({
      alarmReportSelectFilter:
        alarmReportSelectFilter !== null
          ? dayjs(alarmReportSelectFilter).format("DD-MM-YYYY")
          : "",
      alarmReportUserType: alarmReportUserType,
    });
  };
  const [api, contextHolder] = notification.useNotification();
  const noDataNotification = () => {
    api.info({ title: "No Data Available !",
      placement: "bottomRight",
      style: { backgroundColor: "#ceddf5" },
      duration: 2,
    });
  };
  const handleDownloadClick = async () => {
    if (!tableData.length) {
      noDataNotification();
      return;
    } else {
      await download();
    }
  };
  const download = async () => {
    try {
      let userid;
      await dbstorage.get("user").then((user) => {
        userid = user._id;
      });
      const date = alarmReportSelectFilter;
      await notificationFilter.createCsv(
        "alarm_report",
        userid,
        "",
        userGroup,
        date,
        ""
      );
      const count = await notificationFilter.getCount(userid);

      setNotificationCount(count.count);

      // return transformedCsvData;
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (!alarmReportFirstRender) {
      updateQueryParams();
    }
  }, [alarmReportSelectFilter, alarmReportUserType]);

  useEffect(() => {
    fetchData();
  }, [alarmReportSelectFilter, alarmReportUserType]);

  const headers = [
    {
      label: "User Name",
      key: "username",
    },
    {
      label: "Serial Number",
      dataIndex: "serialnumber",
      key: "serialnumber",
    },
    {
      label: "Flood Alarm",
      key: "floodalarm",
    },
    {
      label: "Panic Alarm",
      key: "panicsituation",
    },
    {
      label: "Gas Alarm",
      key: "gasalarm",
    },
    {
      label: "Smoke Alarm",
      key: "smoke",
    },
    {
      label: "Tamper Alarm",
      key: "tamper",
    },
    {
      label: "Total Alarm",
      key: "allalarm",
    },
  ];

  return (
    <>
      <div className="card-background">
        <div className="d-flex justify-content-between mb-3 align-items-center">
          <div className="search-filter d-flex card-heading">
            <DatePicker
              value={alarmReportSelectFilter}
              onChange={handleDatePicker}
              disabledDate={disableFutureDate}
              allowClear={false}
              format="DD-MM-YYYY"
            />
            <Dropdown
              className="drop-down shadow-sm mx-md-3"
              menu={{
                items: selectOptions.items,
                onClick: selectOptions.setFilter,
              }}
              placement="bottomLeft"
            >
              <Button>
                {selectOptions.value}
                <DownOutlined />
              </Button>
            </Dropdown>
            <div className="my-auto">
              Alarm Notifications Datewise Report (
              {alarmReportSelectFilter.$d.getDate()}-
              {alarmReportSelectFilter.$d.getMonth() + 1}-
              {alarmReportSelectFilter.$d.getFullYear()})
            </div>
          </div>

          <Button
            className="border-0 shadow-none me-4"
            icon={
              <Tooltip title="Download">
                <span>
                  <HiOutlineInboxArrowDown className="text-color-grey fs-4" />
                </span>
              </Tooltip>
            }
            type="text"
            onClick={handleDownloadClick}
          />
        </div>
        <Table tableData={tableData} loading={loading} />
      </div>
    </>
  );
};

export default AlarmDatewiseReport;
